export default __webpack_public_path__ + "static/media/Eye.1a294a0e.svg";